const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : process.env.NODE_ENV !== 'production';

export const logger = {
	log: (...args: unknown[]) => {
		if (isDev) {
			// eslint-disable-next-line no-console
			console.log(...args);
		}
	},
	warn: (...args: unknown[]) => {
		console.warn(...args);
	},
	error: (...args: unknown[]) => {
		console.error(...args);
	},
};
